import { Popup as InnerPopup, PopupGroup } from './popup';
const Popup = InnerPopup;
Popup.Group = PopupGroup;
export default Popup;
